import { useEffect, useMemo, useState } from "react";
import { IReanalyzeValues } from "../../../@types/reanalyze";
import { InteractiveParams, RlcsParams } from "../reanalyze-form/types";
import {
  INITIAL_ANALYSIS_SELECTIONS,
  INITIAL_INTERACTIVE_PARAMS,
  INITIAL_RLCS_PARAMS
} from "../reanalyze-popup/consts";

const useReanalyzeForm = (
  initial: IReanalyzeValues,
  suggestedPlatform?: string
) => {
  const [values, setValues] = useState(initial || INITIAL_ANALYSIS_SELECTIONS);
  const [rlcs, setRlcs] = useState<RlcsParams>(INITIAL_RLCS_PARAMS);
  const [interactive, setInteractive] = useState<InteractiveParams>(
    INITIAL_INTERACTIVE_PARAMS
  );

  useEffect(() => {
    if (suggestedPlatform) {
      setRlcs(prev => ({
        ...prev,
        platform: suggestedPlatform,
        locale: suggestedPlatform.match("win*") ? prev.locale : undefined
      }));
    }
  }, [suggestedPlatform]);

  const api = useMemo(() => {
    const handleValuesChange = setValues;

    const handleRlcsChange = (newParam: RlcsParams) => {
      setRlcs(prev => ({
        ...prev,
        ...newParam
      }));
    };

    const handleInteractiveChange = (newParam: InteractiveParams) => {
      setInteractive(prev => ({
        ...prev,
        ...newParam
      }));
    };

    return {
      handleValuesChange,
      handleRlcsChange,
      handleInteractiveChange
    };
  }, []);

  return { values, rlcs, interactive, api };
};
export default useReanalyzeForm;
